"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateProps = exports.toBoolean = void 0;
const validateStateTransitionMessage = (props, propName) => {
  if (props.allowFocusOnDisable && (props.disabled !== null || props['aria-disabled']) && !props[propName]) {
    // eslint-disable-next-line no-console
    console.error(`
        Missing or invalid value for ${propName}.
        If this button can receive focus when disabled (i.e. allowFocusOnDisable prop is true),
        you need to provide localized string values for the enabled and disabled states.
        These strings are used to announce the state change by assistive technologies.
        Hence, these should be specified for a better, accessible experience.
        For e.g.
        <Button
            disabled={someLogic()}
            allowFocusOnDisable
            disabledMessage="Please complete required form fields to enable form submission."
            enabledMessage="Please press the submit button to proceed.">
            Submit
        </Button>
        `);
  }
};
const validateProps = props => {
  validateStateTransitionMessage(props, 'disabledMessage');
  validateStateTransitionMessage(props, 'enabledMessage');
};
exports.validateProps = validateProps;
const toBoolean = value => {
  if (!value) return value;
  return value === true || value === 'true';
};
exports.toBoolean = toBoolean;